import React from "react";
import { AuthContainer } from "./style";
import * as authApi from "api/auth";
import Input from "components/input";
import Button from "components/button";
import { FiKey } from "react-icons/fi";
import MainContext from "contexts/main";
import { toast } from "react-toastify";

const Auth = () => {
  const { setUser } = React.useContext(MainContext);
  const [state, dispatch] = React.useReducer(
    (state, action) => {
      switch (action.type) {
        case "TOGGLE_LOADING":
          return { ...state, loading: !state.loading };
        case "SET_TYPE":
          return { ...state, type: action.payload };
        case "CHANGE_VALUE":
          return {
            ...state,
            formData: {
              ...state.formData,
              [action.payload.name]: action.payload.value,
            },
          };
        case "SET_FORM_ERRORS":
          return { ...state, formErrors: action.payload, loading: false };
        default:
          return state;
      }
    },
    {
      loading: false,
      formData: {
        password: "",
        password_confirmation: "",
      },
      formErrors: {},
    }
  );
  const checkDataError = () => {
    const errors = {};
    if (!state.formData.password) {
      errors.password = "اجباری می باشد";
    }
    if (state.formData.password.length < 6) {
      errors.password = "حداقل 6 کاراکتر می باشد";
    }
    if (state.formData.password_confirmation !== state.formData.password) {
      errors.password_confirmation = "تکرار رمز عبور اشتباه است";
    }
    if (Object.keys(errors).length > 0) {
      return errors;
    } else {
      return false;
    }
  };

  const changing = async () => {
    dispatch({ type: "TOGGLE_LOADING" });
    const errors = checkDataError();
    if (errors) {
      dispatch({ type: "SET_FORM_ERRORS", payload: errors });
    } else {
      await authApi
        .changePassword(state.formData)
        .then((res) => {
          setUser(res.data);
          toast.success("رمز عبور با موفقیت تغییر یافت");
          dispatch({ type: "TOGGLE_LOADING" });
        })
        .catch((err) => {
          dispatch({ type: "TOGGLE_LOADING" });
        });
    }
  };

  const handleChange = (e) => {
    dispatch({
      type: "CHANGE_VALUE",
      payload: { name: e.target.name, value: e.target.value },
    });
  };

  return (
    <AuthContainer>
      <section className="form">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            changing();
          }}
        >
          <div className="form-item">
            <Input
              label="کلمه عبور"
              name="password"
              type="password"
              value={state.formData.password}
              onChange={handleChange}
              error={state.formErrors.password}
              ltr
              icon={<FiKey />}
            />
          </div>
          <div className="form-item">
            <Input
              label="تکرار کلمه عبور"
              name="password_confirmation"
              type="password"
              value={state.formData.password_confirmation}
              onChange={handleChange}
              error={state.formErrors.password_confirmation}
              ltr
              icon={<FiKey />}
            />
          </div>
          <div className="buttons">
            <Button title="تایید" loading={state.loading} />
          </div>
        </form>
      </section>
    </AuthContainer>
  );
};
export default Auth;
